import { mapGetters } from 'vuex';
import Store from '@/store';
import UserService from '@/services/UserService';
import TenantService from '@/services/TenantService';

export default {
    data() {
        return {};
    },

    computed: {
        // Map store data to computed properties
        // to be available in all components
        ...mapGetters(['tenant', 'user', 'appConfig', 'isOnline', 'device'])
    },

    filters: {
        date(date) {
            if(!(date instanceof moment)) {
                date = moment(date)
            }

            if(!date.isValid()) return null;

            if(!Store.getters.tenant) {
                return date.format('YYYY/MM/DD')
            }

            return ['me', 'sr', 'ba'].includes(Store.getters.tenant.venue.locale)
                ? date.format('DD.MM.YYYY.')
                : date.format('YYYY/MM/DD')
        },

        dateTime(date) {
            if(!(date instanceof moment)) {
                date = moment(date)
            }

            if(!date.isValid()) return null;

            if(!Store.getters.tenant) {
                return date.format('YYYY/MM/DD HH:mm:ss')
            }

            return ['me', 'sr', 'ba'].includes(Store.getters.tenant.venue.locale)
                ? date.format('DD.MM.YYYY. HH:mm:ss')
                : date.format('YYYY/MM/DD HH:mm:ss')
        },

        dateTimeHuman(date) {
            if(!(date instanceof moment)) {
                date = moment(date)
            }

            if(!date.isValid()) return null;

            if(!Store.getters.tenant) {
                return date.format('D MMM HH:mm')
            }

            return ['me', 'sr', 'ba'].includes(Store.getters.tenant.venue.locale)
                ? date.format('D MMM HH:mm')
                : date.format('D MMM HH:mm')
        },

        price(value) {
            if(!value || isNaN(value)) {
                return ''
            }

            return Money.parse(value).toFormat();
        },

        quantity(value) {
            if(!value || isNaN(value)) {
                return ''
            }

            return _.round(value, 3);
        },
    },

    methods: {
        /**
         * Check if user has a one permission or
         * multiple specified permissions
         *
         * @param permissions
         * @returns {boolean}
         */
        allows(permissions, user = null) {
            return UserService.allows(permissions, user);
        },

        /**
         * Check if tenant contract has a one permission or
         * multiple specified permissions
         *
         * @param permissions
         * @returns {boolean}
         */
        contractAllows(permissions) {
            return TenantService.contractAllows(permissions);
        },

        nl2br(text) {
            if(!text) return ''

            return text.replace(/(?:\r\n|\r|\n)/g, '<br>')
        }
    }
};
